import { PageContainer, Card, Badge } from '@aimsos/ui';
import { Users, Monitor, UserPlus, ShieldCheck, User } from 'lucide-react';

const STATS = [
  { label: 'Total Users', value: '1,284', Icon: Users, trend: '+12 this month', color: 'text-blue-600 dark:text-blue-400', bg: 'bg-blue-50 dark:bg-blue-900/20' },
  { label: 'Active Sessions', value: '47', Icon: Monitor, trend: 'Right now', color: 'text-green-600 dark:text-green-400', bg: 'bg-green-50 dark:bg-green-900/20' },
  { label: 'Pending Invites', value: '8', Icon: UserPlus, trend: '3 expire soon', color: 'text-yellow-600 dark:text-yellow-400', bg: 'bg-yellow-50 dark:bg-yellow-900/20' },
  { label: 'Roles Defined', value: '6', Icon: ShieldCheck, trend: 'Stable', color: 'text-purple-600 dark:text-purple-400', bg: 'bg-purple-50 dark:bg-purple-900/20' },
];

const RECENT_USERS = [
  { id: 1, name: 'Alice Johnson', email: 'alice@company.com', role: 'Admin', status: 'Active', joined: '2 days ago' },
  { id: 2, name: 'Bob Smith', email: 'bob@company.com', role: 'Editor', status: 'Active', joined: '1 week ago' },
  { id: 3, name: 'Carol White', email: 'carol@company.com', role: 'Viewer', status: 'Pending', joined: '2 weeks ago' },
];

const statusVariant = { Active: 'success', Pending: 'warning', Suspended: 'danger' };

const Overview = () => (
  <PageContainer title="User Management Overview">
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {STATS.map((stat) => (
        <Card key={stat.label}>
          <Card.Body>
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm text-content-muted">{stat.label}</p>
                <p className="mt-1 text-3xl font-bold text-content">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs text-content-faint">{stat.trend}</p>
              </div>
              <div className={['rounded-lg p-2.5', stat.bg].join(' ')}>
                <stat.Icon size={22} className={stat.color} />
              </div>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>

    <Card className="mt-6">
      <Card.Header title="Recently Added Users" />
      <div className="divide-y divide-edge">
        {RECENT_USERS.map((user) => (
          <div key={user.id} className="flex items-center gap-4 px-6 py-3">
            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-brand-100 dark:bg-brand-900">
              <User size={16} className="text-brand-700 dark:text-brand-300" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-content">{user.name}</p>
              <p className="text-xs text-content-muted">{user.email}</p>
            </div>
            <div className="flex flex-shrink-0 items-center gap-3">
              <span className="text-xs text-gray-400">{user.role}</span>
              <Badge variant={statusVariant[user.status]}>{user.status}</Badge>
              <span className="text-xs text-gray-400">{user.joined}</span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  </PageContainer>
);

export default Overview;
